export default __webpack_public_path__ + "a558849f04dc8ec9dc17ec7258f827fc.png";